// Note: Main Layout
// This will be the main layout for the application
// Has the Chat and dashboard navigation

import { AppWindowIcon, MessageCircleIcon, Box } from 'lucide-react'
import { useState } from 'react'
import { Outlet, useNavigate } from 'react-router'

import { NavUser } from '@/components/NavigationUser'
import { Avatar, AvatarImage } from '@/components/ui/avatar'

import {
  SidebarInset,
  SidebarProvider,
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
} from '../components/ui/sidebar'

const NAV_DATA = [
  {
    title: 'Chats',
    url: '/chat',
    icon: MessageCircleIcon,
    isActive: true,
  },
  {
    title: 'Dashboard',
    url: '/dashboard',
    icon: AppWindowIcon,
    isActive: true,
  },
  // Add Slotting below Dashboard
  {
    title: 'Slotting',
    url: '/slotting',
    icon: Box, // Replace with a more appropriate icon if available
    isActive: true,
  },
]

export default function MainLayout() {
  const [activeItem, setActiveItem] = useState(NAV_DATA[0])
  const navigate = useNavigate()

  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': '48px',
          '--sidebar-width-mobile': '20rem',
        } as React.CSSProperties
      }
    >
      <Sidebar
        collapsible="icon"
        className="overflow-hidden [&>[data-sidebar=sidebar]]:flex-row bg-background"
      >
        <Sidebar
          collapsible="none"
          className="!w-[calc(var(--sidebar-width-icon)_+_1px)] border-r"
        >
          <SidebarHeader>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton size="lg" asChild className="md:h-8 md:p-0">
                  <Avatar
                    className="w-16 h-16 -ml-1 transition-all duration-200 hover:scale-125 hover:shadow-lg cursor-pointer"
                    onClick={() => navigate('/chat')}
                  >
                    <AvatarImage
                      src={'/avatar.png'}
                      alt={'OpsAI logo'}
                      className="w-12 h-12 object-cover"
                    />
                  </Avatar>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarHeader>

          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupContent className="px-1.5 md:px-0">
                <SidebarMenu>
                  {NAV_DATA.map((item) => (
                    <SidebarMenuItem key={item.title}>
                      <SidebarMenuButton
                        tooltip={{
                          children: item.title,
                          hidden: false,
                        }}
                        onClick={async () => {
                          setActiveItem(item)
                          await navigate(item.url)
                        }}
                        isActive={activeItem.title === item.title}
                        className="px-2.5 md:px-2"
                      >
                        <item.icon />
                        <span>{item.title}</span>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>

          <SidebarFooter>
            <NavUser />
          </SidebarFooter>
        </Sidebar>
      </Sidebar>
      <SidebarInset className="flex-1 overflow-hidden">
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
